import React, { useState } from 'react'
import { ContactChicken, ContactForm, ContactInput, ContactQuote, ContactQuoteWrapper, ContactStrong, ContactText, ContactTitle, ContactWrapper, Max, NoBgButton } from '../../GlobalStyles'
import SplitLine from '../Lines/SplitLine'
import chicken from "../../Images/mic.png";
import { Component } from 'react';
import axios from "axios";

class Contacts extends Component{

    constructor(props) {
        super(props);
    
        this.state = {
          email: "",
          message: ""
        };
    
        this.handleEmailChange = this.handleChange.bind(this, "email");
        this.handleMessageChange = this.handleChange.bind(this, "message");
        this.handleSubmit = this.handleSubmit.bind(this);
      }

      handleChange(keyName, e) {
        this.setState({ [keyName]: e.target.value });
      }
    
      handleSubmit(e) {
        e.preventDefault();
    
        var params = new URLSearchParams();
        params.append("email", this.state.email);
        params.append("message", this.state.message);
    
        axios
          .post("/api/discord.php", params)
          .then((response) => {
            window.location.reload();
          })
          .catch((error) => {
            console.log(error.stack);
          });
      }
      
      render() {
        return (
            <React.Fragment>
                <ContactWrapper>
                    <SplitLine />
                    <ContactChicken src={chicken} />
                    <ContactQuoteWrapper>
                    <ContactQuote>
                        {this.props.props.Quote}
                    </ContactQuote>
                    </ContactQuoteWrapper>
                    <ContactForm onSubmit={this.handleSubmit}>
                    <ContactTitle>get <ContactStrong>in touch</ContactStrong></ContactTitle>
                    <Max>
                        <ContactInput placeholder={"Email address"}  defaultValue={this.state.email} onChange={this.handleEmailChange} required/>
                        <ContactText placeholder={"Your message"} defaultValue={this.state.message} onChange={this.handleMessageChange} required/>
                        <NoBgButton>Contact me</NoBgButton>
                        <ContactQuote left>
                        {this.props.props.Policy}
                        </ContactQuote>
                    </Max>
                    </ContactForm>
                </ContactWrapper>
            </React.Fragment>
        )
      }

}

export default Contacts
